export const viewTitle = "Опись дел, документов";
export const viewUniqKey = "inventoryReportView";
